import { select, DisposalSet } from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';

const gc = new DisposalSet();


declare function ga(...args: any[]): void;

registerFragment('ay-professional-profile', (fragEl, configuration, meta) => {
    const printBtnEl = fragEl.querySelector<HTMLAnchorElement>('.ay-proff-bio__social--item--print');
    if (printBtnEl) {
        (gc.register(printBtnEl).addListener('click', (e) => {
            e.stopPropagation();
            e.stopPropagation();
            window.print();
        }));
    }

    const vCardBtnEl = fragEl.querySelector<HTMLAnchorElement>('.ay-proff-bio__social--item--vcard');
    if (vCardBtnEl) {
        const professionalName = vCardBtnEl.dataset.professionalName || 'unknown';

        if (typeof ga !== 'undefined') {
            ga('set', 'Professional Profile', encodeURIComponent(professionalName));
        }

        gc.register(vCardBtnEl).addListener('click', (e) => {
            if (typeof ga !== 'undefined') {
                ga('send', 'event', {
                    eventCategory: 'Download - Vcard',
                    eventAction: 'click',
                    eventLabel: e
                });
            }
        });
    }
});


if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}